/* @flow */

export const INTEREST_KEYWORDS = 'INTEREST_KEYWORDS';
export const INTEREST_AUTOCOMPLETE = 'INTEREST_AUTOCOMPLETE';
